import { action, computed, observable } from 'mobx';
import { IServiceAppConfig, IServiceAppConfigs, IAppAndBUIDConfigs, configType } from './IConfig';

export class Config {
    @observable public config: IServiceAppConfigs;

    constructor(appConfig: IServiceAppConfig) {
        const ecommConfig = {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ...(window.site as any)?.loyaltyConfig
        };
        this.updateConfig({ appConfig, buidConfig: { ...ecommConfig } });
    }

    @action
    public updateConfig(config: IAppAndBUIDConfigs) {
        this.config = {
            ...this.config,
            ...config?.appConfig,
            ...config?.buidConfig
        };
    }

    @computed
    public get brandId(): configType {
        return this.config?.brandId;
    }

    @computed
    public get regionId(): configType {
        return this.config?.regionId;
    }

    @computed
    public get languageId(): configType {
        return this.config?.language?.id;
    }

    @computed
    public get apiAuthToken(): configType {
        return this.config?.pgApiTokens?.loyaltyGraphql;
    }

    @computed
    public get businessUnitId(): configType {
        return this.config?.businessUnitId;
    }

    @computed
    public get pgGraphqlBasePath(): configType {
        return this.config?.loyalty.apiPath;
    }

    public get pgGraphqlJWT(): configType {
        return this.config?.loyalty.JWTToken;
    }
}
